import type { HTMLAttributes, ReactNode } from 'react';
import { stripHtml } from '@/lib/homepage-mappers';
import { cn } from '@/utils/cn';

type CmsRichTextHeadingProps = HTMLAttributes<HTMLHeadingElement> & {
  as?: 'h1' | 'h2';
  html?: string | null;
  fallback: ReactNode;
};

/** True when a Strapi rich-text value contains visible text. */
export function hasRichTextContent(html?: string | null): html is string {
  return Boolean(stripHtml(html));
}

/**
 * Preserve the existing semantic heading while allowing Strapi CKEditor HTML
 * to replace its legacy scalar text only when the rich-text field has content.
 */
export default function CmsRichTextHeading({
  as: Tag = 'h1',
  html,
  fallback,
  className,
  ...props
}: CmsRichTextHeadingProps) {
  if (hasRichTextContent(html)) {
    return (
      <Tag
        {...props}
        className={cn(className, '[&_p]:m-0')}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  return (
    <Tag {...props} className={className}>
      {fallback}
    </Tag>
  );
}
